module.exports = __webpack_public_path__ + "static/media/icon-facebook.baca7ebc.jpg";